// Lib
import React from 'react';

import { cn } from '@components/lib/utils';

interface BrandProgressBarProps {
  step: number;
}

const segmentClass = (active: boolean) =>
  cn('h-[5px] w-full', active ? 'bg-marble-blue-400' : 'bg-marble-bg-200');

export const BrandProgressBar: React.FC<BrandProgressBarProps> = ({ step }) => (
  <div className="mb-9 flex gap-3 py-[13.5px]">
    <div className={segmentClass(true)} />
    <div className={segmentClass(step === 1 || step === 2)} />
    <div className={segmentClass(step === 2)} />
  </div>
);
